import ActionMenu, { Action } from "../../../../components/ui/materialui/actionMenu";
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import { usePermissions } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";

interface IProps {
    onUpdate: () => void;
    onDelete: () => void;
    onVerDetalle: () => void;
}

const AccionesTablaDesarrollo: React.FC<IProps> = ({ onUpdate, onDelete, onVerDetalle }) => {
    const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);

const actions: Action[] = [];     
  if (puedeEditar) {
    actions.push(
      { label: "Ver detalle", icon: <SearchIcon fontSize="small" />, onClick: onVerDetalle},
      { label: "Actualizar", icon: <EditIcon fontSize="small" />, onClick: onUpdate },
      { label: "Eliminar", icon: <DeleteIcon fontSize="small" />, onClick: onDelete },
    );
  } else if(hasPermission(TipoFuncionalidad.Maestros_ver)) {
    actions.push(
      { label: "Ver detalle", icon: <SearchIcon fontSize="small" />, onClick: onVerDetalle},
    );
  }

    return (
        <>
            <ActionMenu actions={actions} />
        </>
    );
}

export default AccionesTablaDesarrollo;